import { PUBLIC_CDN_URL, TAG_VERSION } from '@/app/_constants/urls'

export function getCdnUrl(path: string): string {
    if (!path.startsWith('/')) {
        throw new Error('Path must start with a forward slash' + path)
    }

    return `${PUBLIC_CDN_URL}/${TAG_VERSION}${path}`
}
